module.exports = __webpack_public_path__ + "static/img/godwealth_esp.041951c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/godwealth_esp.png
// module id = mNNI
// module chunks = 1